import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CATEGORY_ICONS } from "@/data/categories";

export default function CategoryScroller({ categories }) {
  const scroller = useRef(null);
  const navigate = useNavigate();

  const scroll = (dir) => {
    if (scroller.current) {
      scroller.current.scrollBy({ left: dir * 320, behavior: "smooth" });
    }
  };

  return (
    <div className="relative">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#1f222d]">Popüler İş Kategorileri</h2>
          <p className="text-slate-500 text-sm mt-1">Size uygun sektörü seçin ve ilanları keşfedin</p>
        </div>
        <div className="hidden sm:flex gap-2">
          <button data-testid="cat-scroll-left" onClick={() => scroll(-1)} className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 hover:border-blue-400 transition-colors">
            <ChevronLeft size={20} className="text-[#1f222d]" />
          </button>
          <button data-testid="cat-scroll-right" onClick={() => scroll(1)} className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 hover:border-blue-400 transition-colors">
            <ChevronRight size={20} className="text-[#1f222d]" />
          </button>
        </div>
      </div>

      <div ref={scroller} className="flex gap-4 overflow-x-auto pb-4 scroll-smooth no-scrollbar snap-x">
        {categories.map((c) => {
          const Icon = CATEGORY_ICONS[c.icon] || CATEGORY_ICONS.Briefcase;
          return (
            <button
              key={c.slug}
              data-testid={`category-card-${c.slug}`}
              onClick={() => navigate(`/ilanlar?category=${c.slug}`)}
              className="snap-start min-w-[220px] sm:min-w-[250px] text-left p-6 bg-white border border-slate-200 rounded-2xl hover:border-blue-500 hover:shadow-lg hover:-translate-y-1 transition-all duration-200 flex flex-col justify-between group shrink-0"
            >
              <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                <Icon size={26} className="text-blue-600 group-hover:text-white transition-colors" />
              </div>
              <div>
                <h3 className="font-semibold text-[#1f222d] text-lg">{c.name}</h3>
                <p className="text-sm text-slate-500 mt-1">{c.count?.toLocaleString("tr-TR") || 0} açık ilan</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
